export const VideoPoint = {
  pageName: 'Video',
  pageId: '25103',
  pagePath: '/marketing/Videos',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {
    tab_switch: {
      buttonId: '2510301',
    },
  },
  card: {},
};
